import React from 'react'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import LoadingProgress from '../components/LoadingProgress'
import { Link } from 'react-router-dom'

import { fetchMachines } from '../actions/machines'

import TPVList from '../components/TPVList'
import ErrorMessage from '../components/ErrorMessage'
import "../styles/CustomersAdminView.css"

class TPVsView extends React.Component {
  constructor(props) {
    super(props)
    this.state = { filter: '' }
  }

  componentDidMount() {
    this.props.fetchMachines()
  }

  render() {
    const { machines, error, role } = this.props
    const { filter } = this.state

    if (error) {
      return (<ErrorMessage message={error.message} />)
    }

    if (!machines) {
      return <LoadingProgress />
    }

    const q = filter.toLowerCase()
    const filtered = machines.filter(m =>
      (m.Serial || '').toLowerCase().includes(q) ||
      (m.Customer && m.Customer.Fullname ? m.Customer.Fullname.toLowerCase().includes(q) : false)
    )

    return (
      <div className="customers-admin-view">
        <div className="customers-admin-header">
          <div className="header-content">
            <div className="header-text">
              <h1>
                <i className="fas fa-credit-card mr-3"></i>
                <span className="text-vw-dark mr-1">TPVs</span>
              </h1>
            </div>
            <div className="header-actions" style={{ alignItems: 'center' }}>
              <div style={{ position: 'relative', display: 'flex', alignItems: 'center' }}>
                <i className="fas fa-search" style={{ position: 'absolute', left: 10, top: '50%', transform: 'translateY(-50%)', color: '#8a9ab5', fontSize: 13, pointerEvents: 'none' }} />
                <input
                  type="text"
                  placeholder="Filtrar por máquina o cliente..."
                  value={filter}
                  onChange={e => this.setState({ filter: e.target.value })}
                  style={{ padding: '8px 12px 8px 32px', borderRadius: 8, border: '1px solid #e4eaf2', fontSize: 13, color: '#1a2b4a', outline: 'none', background: '#fff', width: 280, lineHeight: 'normal' }}
                />
              </div>
              <span style={{ padding: '3px 12px', borderRadius: 20, background: '#e8f0fe', color: '#3b82f6', fontSize: 13, fontWeight: 600, whiteSpace: 'nowrap' }}>
                {filtered.length}{filter ? ` / ${machines.length}` : ''}
              </span>
            </div>
          </div>
        </div>

        <TPVList machines={filtered} />
      </div>
    )
  }
}

const mapStateToProps = state => ({
  machines: state.machines.machines,
  error: state.machines.error,
  role: state.auth.role
})

const mapDispatchToProps = dispatch => ({
  fetchMachines: bindActionCreators(fetchMachines, dispatch)
})

export default connect(mapStateToProps, mapDispatchToProps)(TPVsView)
